import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { enableMapSet, enablePatches } from 'immer';

import { environment } from '@coin/shared/core/util-environments';
import { AppComponent } from './app/app.component';
import { APP_CONFIG } from './app/app.config';

// Immer resolves its Map/Set support lazily from inside a proxy get trap, so the plugin
// must be registered before the first `produce` that drafts a Map or Set. Registering it in
// a lazy feature module made that a load-order race (GMTEC-24514).
enableMapSet();
enablePatches();

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, APP_CONFIG).catch(err => console.warn(err));
